import React from 'react';
import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';

const EyeIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 22 16">
    <path
      d="M11 0C4.142 0 .886 5.879.096 7.557c-.132.28-.132.604 0 .884C.886 10.121 4.142 16 11 16c6.834 0 10.093-5.837 10.896-7.54a1.078 1.078 0 0 0 0-.92C21.093 5.836 17.834 0 11 0Zm0 3a5 5 0 1 1-.001 10.001A5 5 0 0 1 11 3Zm0 2a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z"
      fill={props.sx?.color || '#080F1D'}
    />
  </SvgIcon>
);

EyeIcon.propTypes = {
  sx: PropTypes.object,
};

export default EyeIcon;
